(function () {
  'use strict';

  function debounce(fn, delay) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function initCollectionSearch(input) {
    if (input.dataset.collectionSearchInit) return;
    input.dataset.collectionSearchInit = '1';

    var list = input.parentNode.nextElementSibling;
    if (!list || list.tagName !== 'UL') return;

    var items = Array.prototype.slice.call(list.querySelectorAll('li'));
    var apiItems = [];

    function getItemText(li) {
      var label = li.querySelector('label');
      if (!label) return '';
      var clone = label.cloneNode(true);
      var svgs = clone.querySelectorAll('svg');
      for (var i = 0; i < svgs.length; i++) svgs[i].remove();
      return clone.textContent.trim().toLowerCase();
    }

    function getItemKey(li) {
      var label = li.querySelector('label');
      return label ? (label.getAttribute('keyFiltreValue') || '') : '';
    }

    function removeApiItems() {
      apiItems.forEach(function (li) {
        if (li.parentNode) li.parentNode.removeChild(li);
      });
      apiItems = [];
    }

    function filterDomItems(q) {
      items.forEach(function (li) {
        if (q) {
          var match = getItemText(li).indexOf(q) !== -1;
          if (match) {
            if (li.classList.contains('hidden')) {
              li.dataset.wasHidden = '1';
              li.classList.remove('hidden');
            }
            li.style.display = '';
          } else {
            li.style.display = 'none';
          }
        } else {
          if (li.dataset.wasHidden) {
            li.classList.add('hidden');
            delete li.dataset.wasHidden;
          }
          li.style.display = '';
        }
      });
    }

    function addApiItem(collection) {
      var li = document.createElement('li');
      li.className = 'list-menu__item facets__item';

      var label = document.createElement('label');
      label.className = 'facet-checkbox';
      label.setAttribute('keyFiltre', 'fk_collection');
      label.setAttribute('keyFiltreValue', collection.key);

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = 'fk_collection';
      checkbox.value = collection.key;

      var svgBox = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgBox.setAttribute('width', '1.6rem'); svgBox.setAttribute('height', '1.6rem');
      svgBox.setAttribute('viewBox', '0 0 16 16'); svgBox.setAttribute('aria-hidden', 'true');
      svgBox.setAttribute('focusable', 'false'); svgBox.style.overflow = 'visible';
      var r1 = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      r1.setAttribute('width', '16'); r1.setAttribute('height', '16');
      r1.setAttribute('stroke', 'currentColor'); r1.setAttribute('fill', 'none'); r1.setAttribute('stroke-width', '1');
      var r2 = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      r2.setAttribute('width', '16'); r2.setAttribute('height', '16');
      r2.setAttribute('stroke', 'none'); r2.setAttribute('fill', '#FCF9F9');
      svgBox.appendChild(r1); svgBox.appendChild(r2);

      var svgCheck = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgCheck.setAttribute('aria-hidden', 'true'); svgCheck.setAttribute('class', 'icon icon-checkmark');
      svgCheck.setAttribute('width', '1.1rem'); svgCheck.setAttribute('height', '0.7rem');
      svgCheck.setAttribute('viewBox', '0 0 11 7'); svgCheck.setAttribute('fill', 'none');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M1.5 3.5L3.5 5.5L9.5 1.5'); path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '2'); path.setAttribute('stroke-linecap', 'round');
      svgCheck.appendChild(path);

      var text = document.createTextNode('\n' + collection.libelle + (collection.qte ? ' (' + collection.qte + ')' : '') + '\n');

      label.appendChild(checkbox);
      label.appendChild(svgBox);
      label.appendChild(svgCheck);
      label.appendChild(text);
      li.appendChild(label);
      list.appendChild(li);
      apiItems.push(li);

      checkbox.addEventListener('change', function () {
        this.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    var doApiSearch = debounce(function (q) {
      var params = bhmoteur && bhmoteur.getParams();
      if (!params || !params.url) return;

      $.ajax({
        url: params.url,
        type: 'POST',
        data: {
          q: q,
          limit: 1,
          from: 0,
          return_aggregations: true,
          is_collection: true,
          collection: params.filter_m_id_collection,
          debug: false
        },
        success: function (d) {
          removeApiItems();
          var agg = d.result && d.result.aggregations;
          if (!agg) return;
          var collectionAgg;
          for (var i = 0; i < agg.length; i++) {
            if (agg[i].key === 'fk_collection') { collectionAgg = agg[i]; break; }
          }
          if (!collectionAgg || !collectionAgg.data) return;

          var domKeys = {};
          items.forEach(function (li) { var k = getItemKey(li); if (k) domKeys[k] = true; });

          collectionAgg.data.forEach(function (c) {
            if (c.libelle.toLowerCase().indexOf(q) !== -1 && !domKeys[c.key]) {
              addApiItem(c);
            }
          });
        },
        error: function () {}
      });
    }, 500);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); }
      if (e.key === 'Escape') { input.value = ''; filterDomItems(''); removeApiItems(); }
    });

    input.addEventListener('input', function (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var q = this.value.trim().toLowerCase();
      removeApiItems();
      if (!q || q.length < 3) { filterDomItems(''); return; }
      filterDomItems(q);
      doApiSearch(q);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-facet-collection-search]').forEach(initCollectionSearch);
  }

  var observer = new MutationObserver(initAll);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
})();
